import React, { Component } from "react";
import TopImgProfile from "../../../Components/Profile/TopImgProfile";
import Header from "../../../Components/MainLayout/Header";
import { connect } from "react-redux";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class ProfileDetails extends Component {
  state = {};
  render() {
    if (this.props.user.role.id === 9) {
      return (
        <div>
          <Header to="/profile" title="Profile Details" />
          <TopImgProfile />
          <div className="container col-12">
            <div className="th-12 th-primary pt-2">General Details</div>
            <div className="my-2">
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Admission Number</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.studentData.admission_no}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Class</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.student_class.class_name}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Section</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.student_section.section_name}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Addmission Date</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.studentData.admission_date}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Guardian Name</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.studentData.father_name}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
            </div>
          </div>
          <div className="container col-12">
            <div className="th-12 th-primary pt-2">Personal Details</div>
            <div className="my-2">
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Gender</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.studentData.gender}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Date of Birth</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.studentData.date_of_birth}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Blood Group</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.studentData.blood_group}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Nationality</div>
                  <div className="col-6 th-12 th-medium">Indian</div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Address</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.studentData.student_current_address}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
            </div>
          </div>
          <div className="container col-12">
            <div className="th-12 mt-4  ">Help</div>
            <div className="th-10 mb-4  ">
              In case, If you have any concerns about your profile details or of
              you want to update any of your information, please contact the
              administration of your institution.
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Header to="/profile" title="Profile Details" />
          <TopImgProfile />
          <div className="container col-12">
            <div className="th-12 th-primary pt-2">General Details</div>
            <div className="my-2">
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Date of joining</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.staffData?.date_of_joining}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Father Name</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.staffData?.father_name}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
            </div>
          </div>
          <div className="container col-12">
            <div className="th-12 th-primary pt-2">Personal Details</div>
            <div className="my-2">
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Gender</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.staffData?.gender}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Date of Birth</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.staffData?.date_of_birth}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Blood Group</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.staffData?.blood_group}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Nationality</div>
                  <div className="col-6 th-12 th-medium">Indian</div>
                </div>
                <hr className="my-0" />
              </div>
              <div>
                <div className="row py-2">
                  <div className="col-6 th-12">Address</div>
                  <div className="col-6 th-12 th-medium">
                    {this.props.user.staffData?.student_current_address}
                  </div>
                </div>
                <hr className="my-0" />
              </div>
            </div>
          </div>
          <div className="container col-12">
            <div className="th-12 mt-4  ">Help</div>
            <div className="th-10 mb-4  ">
              In case, If you have any concerns about your profile details or of
              you want to update any of your information, please contact the
              administration of your institution.
            </div>
          </div>
        </div>
      );
    }
  }
}
export default connect(mapStateToProps)(ProfileDetails);
